import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import StudentLine from "../students/StudentLine";
import StudentForm from "../students/StudentForm";
import { Helmet } from "react-helmet";

class Archive extends Component {
    state = { isModal: false, loading: false, formData: {}, archives: [], classe: "" };
    componentDidMount() { this.getArchives(); }
    async getArchives() {
        this.setState({ loading: false });
        try {
            const response = await axios.get("yearslist");
            if (response.status === 200) this.setState({ archives: (response.data ? response.data?.sort((a, b) => a.id - b.id) : []), loading: true });
        } catch (error) { this.setState({ archives: [], loading: true }); }
    }
    showModal = (student = null, classe = false) => {
        this.setState((state) => ({ isModal: !state.isModal, formData: student, classe: classe ? student : null }));
    };
    render() {
        const archives = Array.isArray(this.state.archives) ? this.state.archives : [];
        const totalStudents = archives.reduce((total, year) => total + (year.students?.length || 0), 0);
        const labels = archives.map((year) => year.year);
        const data = archives.map((year) => year.students?.length || 0);
        const latestYear = archives.length ? archives[0]?.year : "—";
        return (
            <main className="rh-archives">
                <Helmet><title>{process.env.REACT_APP_NAME} | Archives RH</title></Helmet>
                <header className="rh-archives-hero">
                    <div className="rh-archives-hero__glow" />
                    <div className="rh-archives-hero__content">
                        <div className="rh-archives-hero__icon"><FeatherIcon icon="archive" size={27} /></div>
                        <div><span className="rh-archives-hero__eyebrow">Mémoire scolaire</span><h1>Archives des élèves</h1><p>Retrouvez les parcours clôturés, année par année, dans un espace fiable et organisé.</p></div>
                    </div>
                    <div className="rh-archives-hero__stats">
                        <div><strong>{archives.length}</strong><span>Années conservées</span></div><i />
                        <div><strong>{totalStudents}</strong><span>Dossiers élèves</span></div><i />
                        <div><strong>{latestYear}</strong><span>Archive récente</span></div>
                    </div>
                </header>
                <section className="rh-archives-section">
                    <div className="rh-archives-section__heading">
                        <div><span>Chronologie</span><h2>Années scolaires archivées</h2></div>
                        <span className="rh-archives-section__count">{archives.length} période{archives.length > 1 ? "s" : ""}</span>
                    </div>
                    {!this.state.loading ? (
                        <div className="rh-archives-loading"><FeatherIcon className="user-search-spin" icon="loader" /><span>Ouverture des archives…</span></div>
                    ) : archives.length ? (
                        <div className="rh-archives-grid">
                            {archives.map((year, index) => {
                                const students = year.students?.length || 0;
                                return (
                                    <Link to={`/archives/student/${year.id}`} className="rh-archive-card" key={year.id}>
                                        <div className="rh-archive-card__top"><span className="rh-archive-card__index">{String(index + 1).padStart(2, "0")}</span><span className="rh-archive-card__status"><i />{ year.status == 1 ? "Encours" : " Clôturée" }</span></div>
                                        <div className="rh-archive-card__folder"><FeatherIcon icon="folder" size={25} /></div>
                                        <span className="rh-archive-card__label">Année scolaire</span><h3>{year.year}</h3>
                                        <div className="rh-archive-card__footer"><span><FeatherIcon icon="users" size={16} /> {students} élève{students > 1 ? "s" : ""}</span><b>Explorer <FeatherIcon icon="arrow-up-right" size={17} /></b></div>
                                    </Link>
                                );
                            })}
                        </div>
                    ) : null}
                </section>
                {this.state.loading && !archives.length && (
                    <div className="rh-archives-empty"><span><FeatherIcon icon="inbox" size={26} /></span><strong>Aucune archive disponible</strong><small>Les années clôturées apparaîtront ici automatiquement.</small></div>
                )}
                {labels.length > 0 && <section className="rh-archives-chart">
                    <header><span><FeatherIcon icon="activity" size={19} /></span><div><small>Vue d’ensemble</small><h2>Évolution des effectifs archivés</h2></div></header>
                    <div className="rh-archives-chart__body"><StudentLine labels={labels} data={data} title="Archives des élèves" /></div>
                </section>}
                <StudentForm isArchived isModal={this.state.isModal} formData={this.state.formData} classe={this.state.classe} showModal={this.showModal} />
            </main>
        );
    }
}

export default Archive;
